// Corejs
import 'core-js/es/symbol'
import 'core-js/es/promise'
import 'core-js/es/array/find'
import 'core-js/es/array/from'

// Polifill
import smoothscroll from 'smoothscroll-polyfill'
smoothscroll.polyfill()

// CSS
import '@/scss/form.scss'

// Flatpickr
import flatpickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.min.css'
import { Japanese } from 'flatpickr/dist/l10n/ja.js'
flatpickr.localize(Japanese)

// Vue
import Vue from 'vue'
import VueCompositionApi from '@vue/composition-api'
import { Plugin } from 'vue-fragment'

// Composition API
Vue.use(VueCompositionApi)
Vue.use(Plugin)

Vue.config.productionTip = true

import App from '@/component/form/App.vue'

const root_element = document.querySelector<HTMLElement>('embed-form')

if (root_element) {
    // const scopedSlotElements: { [key: string]: any } = {}
    // const templates = root_element.querySelectorAll('template')
    // Array.prototype.slice.call(templates, 0).forEach((el) => {
    //     for (let i = 0; i < el.attributes.length; i += 1) {
    //         const attribute = el.attributes[i]

    //         const name = (() => {
    //             if (attribute.name.toLowerCase().match(/^(v-slot:|#)/)) {
    //                 return attribute.name.replace(/^(v-slot:|#)/, '')
    //             }

    //             return false
    //         })()

    //         if (name !== false) {
    //             const componentName = `form-slot-template-${name}`
    //             Vue.component(componentName, {
    //                 template: `<fragment>${el.innerHTML}</fragment>`,
    //             })
    //             scopedSlotElements[name] = componentName
    //         }
    //     }
    // })
    const json = (() => {
        try {
            return JSON.parse(
                root_element.innerHTML.replace(/="(.*?)"/g, '=\\"$1\\"')
            )
        } catch (e) {
            return {}
        }
    })()

    new Vue({
        render: (h) => {
            // const scopedSlots: { [key: string]: any } = {}
            // Object.keys(scopedSlotElements).forEach((key) => {
            //     scopedSlots[key] = () => h(scopedSlotElements[key])
            // })

            return h(App, {
                props: {
                    formId: parseInt(root_element.dataset.formId || '0'),
                    basePath: root_element.dataset.basePath || '',
                },
                // scopedSlots,
            })
        },
        data: json,
    }).$mount(root_element)
}
